import Loadable from 'react-loadable';

import reducerRegistry from '../../store/reducerRegistry';

import showsIndexReducer, { ShowsIndexState } from './reducers';

export interface State {
    showsIndex: ShowsIndexState;
}

reducerRegistry.register('showsIndex', showsIndexReducer);

export default Loadable({
    loader: () => import('./ShowsIndexPage'),
    loading: () => null,
});
